import axiosInstance from '@/plugins/axios';

// Classificação de Análise (Rubricas, CBO, Horários e Jornadas) — listas read-only servidas pelo
// BFF a partir do CSV curado (CON-5295/5296/5297). Base = BFF (axiosInstance), não o parser.
// O contrato (search/filters/export) é idêntico entre os domínios; só muda a base.
export function criarServiceClassificacaoAnalise(base) {
  return {
    /**
     * @param {*} body
     * @param {{ page?: number, size?: number, sort?: string }} [opts]
     **/
    search: (body, { page = 0, size = 50, sort } = {}) =>
      axiosInstance.post(`${base}/search`, body ?? {}, {
        params: { page, size, ...(sort ? { sort } : {}) },
      }),
    filters: () => axiosInstance.get(`${base}/filters`),
    exportData: (body) =>
      axiosInstance.post(`${base}/export`, body ?? {}, { responseType: 'blob' }),
  };
}

// domínio padrão (Rubricas) — compat com quem importa o default.
const ServiceClassificacaoAnalise = criarServiceClassificacaoAnalise(
  'configuracoes/rubricas/classificacao-analise',
);

export default ServiceClassificacaoAnalise;
